import React, { useState } from "react";
import { Input, Upload, message, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import DocumentItem from "./DocumentItem";
import { Button1 } from "../../../../../common/Buttons";
import { ClassicButton } from "../../../../ButtonWithLoading";
import { useDispatch } from "react-redux";
import {
  addOrderDocument,
  deleteOrderDocument,
} from "../../../../../../redux/Actions/orderDocumentAction";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

function AttachOrderDocument({ disabled, orderId, order_documents }) {
  const dispatch = useDispatch();
  const [CreateNew, setCreateNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Data, setData] = useState({
    title: "",
    image: false,
  });

  const attachDocument = () => {
    // setCreateNew(true);
    setLoading(true);
    const variables = {
      title: Data.title,
      asset: Data.image,
    };
    dispatch(addOrderDocument(orderId, variables)).then((res) => {
      if (res.success) {
        setData({
          title: "",
          image: false,
        });
        message.success("Saved successfully");
        setCreateNew(false);
        setLoading(false);
      } else {
        message.success("Error occurred");
        setLoading(false);
      }
    });
  };

  const cancelCreate = () => {
    setData({
      title: "",
      image: false,
    });
    setCreateNew(false);
  };

  const propsImage = {
    name: "file",
    onChange(info) {
      if (info.file.status === "done") {
        getBase64(info.file.originFileObj, (imageUrl) =>
          setData({ ...Data, image: imageUrl })
        );
      }
      if (info.file.status === "removed" && info.fileList.length === 0) {
        setData({ ...Data, image: false });
      }
    },
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <div>
      <DocumentItem
        documents={order_documents}
        deleteOrderDocument={disabled ? false : (order_id, record_id) => dispatch(deleteOrderDocument(order_id, record_id))}
      />

      {CreateNew && (
        <>
          <div className="d-flex justify-content-between">
            <Input
              className="mr-2"
              placeholder="Document title"
              value={Data.title}
              onChange={(e) => setData({ ...Data, title: e.target.value })}
            />
            <div
              className="d-flex justify-content-end"
              style={{ width: "50%" }}
            >
              <Upload {...propsImage} customRequest={dummyRequest}>
                {Data.image == false && (
                  <Button style={{ width: 150 }}>
                    <UploadOutlined /> Upload
                  </Button>
                )}
              </Upload>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-end mt-2 mb-4">
              <ClassicButton
                style={{ width: 150 }}
                loading={loading}
                text="Save a new document"
                onClick={() => attachDocument()}
              />
            </div>
          </div>
        </>
      )}
      {!disabled && (
        <>
          <div className="my-4">
            <div style={{ position: "relative", minHeight: 30 }}>
              <Button1
                style={{
                  position: "absolute",
                  top: "-16px",
                  left: "50%",
                  transform: "translate(-50%, 0px)",
                }}
                text={CreateNew ? "Cancel" : "Upload a new document"}
                option={CreateNew ? "minus" : "upload"}
                onClick={
                  CreateNew ? () => cancelCreate() : () => setCreateNew(true)
                }
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
export default AttachOrderDocument;
